import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import Comunicado from 'Component/Comunicado';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import Parametros from 'Interface/Requisicao';
import { useRecuperarComunicadosQuery } from 'View/Service/Default/Comunicados';

const Todos = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const {
    data: { comunicados, paginacao } = {},
    isFetching,
    isLoading,
  } = useRecuperarComunicadosQuery({
    contain: ['Usuarios'],
    page: searchParams.get('pagina') || 1,
    sort: 'modificado',
    direction: 'desc',
  } as Parametros);

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Todos os comunicados"
        descricao="Listagem de todos os comunicados cadastradas no banco de dados"
      />
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={comunicados?.length} />
      <div className="bg-white shadow-sm rounded p-3">
        {comunicados?.map((comunicado, indice) => (
          <Comunicado
            key={`${comunicado.id}-${comunicado.modificado}`}
            dados={comunicado}
            indice={indice}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Todos;
